module.exports = __webpack_public_path__ + "img/grilled_cheese_320px.bd6aa55d.jpg";